import React from "react";
import { withRouter } from "react-router-dom";
import {
  Select,
  Button,
  TextField,
  InputAdornment,
  Snackbar,
  SnackbarContent,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import Layout from "../layouts/Layout";
import WarningIcon from "@material-ui/icons/Warning";
import Moment from "moment";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import AddNewDialog from "../components/AddNewDialog";
import Loading from "../components/Loading";
const variantIcon = {
  warning: WarningIcon
};

const stylesSnackbar = theme => ({
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(stylesSnackbar)(MySnackbarContent);

const stylesMain = theme => ({
  margin: {
    margin: "8px"
  },
  textField: {
    flexBasis: 200
  }
});
class Deals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: new Date(),
      sellerId: "NONE",
      buyerId: "NONE",
      unit: "NONE",
      currentSellerName: "",
      currentBuyerName: "",
      currentProduct: "NONE",
      currentGSTCondition: "NONE",
      currentTypeOfRate: "NONE",
      quantity: "",
      activeStatus: true,
      rate: "",
      gstCondition: ["under", "outer"],
      typeOfRate: ["FOR", "NOT"],
      truckTrolla: ["TRUCK", "TROLLA"],
      truckTrollaName: "NONE",
      truckTrollaQuantity: "",
      brokerage: "",
      buyerBrokerage: "",
      sellerBrokerage: "",
      amount: "",
      description: "",
      openSnackBar: false,
      buyerCustomers: [],
      open: false,
      bardanaDispatchName: "",
      bardanaDispatchDialog: false,
      type: null,
      name: "",
      email: "",
      phoneNumber: "",
      gstNumber: "",
      panNumber: "",
      tinNumber: "",
      address: "",
      sellerCustomers: [],
      snackbarMessage: "",
      organisationId: "",
      sellerThrough: "",
      buyerThrough: "",
      currentBardanaCondition: "",
      currentDealQuality: "",
      currentDispatchCondition: "",
      dialogFor: null,
      entryName: "",
      isLoading: false
    };
  }
  componentWillMount() {
    this.initialiseData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initialiseData(nextProps);
  }
  initialiseData(whichProps) {
    this.setState({
      buyerCustomers: whichProps.buyerCustomers,
      sellerCustomers: whichProps.sellerCustomers,
      isLoading: whichProps.isLoading
    });
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationId: whichProps.organisations.organisationId
      });
    }
  }
  handleDialogOpen = currentCustomer => {
    this.setState({ open: true, currentCustomer: currentCustomer });
  };
  handleBDDialogOpen = type => {
    this.setState({ bardanaDispatchDialog: true, type: type });
  };
  handleAddNewDialog = dialogFor => {
    this.setState({ openAddNewDialog: true, dialogFor });
  };
  handleCloseAddNewDialog = () => {
    this.setState({
      openAddNewDialog: false,
      dialogFor: null,
      entryName: null
    });
  };

  handleDialogClose = () => {
    this.setState({
      open: false,
      name: "",
      email: "",
      phoneNumber: "",
      address: "",
      gstNumber: "",
      panNumber: "",
      tinNumber: "",
      bardanaDispatchDialog: false,
      type: null
    });
  };
  handleChange = name => event => {
    if (name === "panNumber" || name === "gstNumber") {
      this.setState({ [name]: event.target.value.toUpperCase() });
    } else if (event.target.value === "addBardanaCondition") {
      this.handleAddNewDialog(event.target.value);
    } else if (event.target.value === "addDispatchCondition") {
      this.handleAddNewDialog(event.target.value);
    } else if (event.target.value === "addNewProduct") {
      this.handleAddNewDialog(event.target.value);
    } else if (event.target.value === "addNewUnit") {
      this.handleAddNewDialog(event.target.value);
    } else if (event.target.value === "addDealQuality") {
      this.handleAddNewDialog(event.target.value);
    } else {
      this.setState({ [name]: event.target.value });
    }
  };
  handleDateChange = name => event => {
    this.setState({ [name]: new Date(event.target.value) });
  };
  handleCustomer = customer => event => {
    if (event.target.value === "add") {
      this.handleDialogOpen(customer);
    } else if (customer === "currentSellerName") {
      this.handleSellerChange(event);
    } else {
      this.handleBuyerChange(event);
    }
  };
  handleSellerChange = event => {
    let sellerName = this.props.customers.find(o => o.id === event.target.value)
      .name;
    this.setState({
      sellerId: event.target.value,
      currentSellerName: sellerName
    });
    let buyerCustomers = this.props.customers.filter(
      customers => customers.id !== event.target.value
    );
    this.setState({ buyerCustomers });
  };
  handleCustomerAdd = customer => {
    this.props
      .addCustomer(
        this.state.name,
        this.state.email,
        this.state.phoneNumber,
        this.state.address,
        this.state.gstNumber,
        this.state.panNumber,
        this.state.tinNumber
      )
      .then(doc => {
        if (customer === "currentSellerName") {
          let sellerName = this.props.customers.find(o => o.id === doc.id).name;
          this.setState({
            sellerId: doc.id,
            currentSellerName: sellerName
          });
          let buyerCustomers = this.props.customers.filter(
            customers => customers.id !== doc.id
          );
          this.setState({ buyerCustomers });
        } else {
          let buyerName = this.props.customers.find(o => o.id === doc.id).name;
          this.setState({ buyerId: doc.id, currentBuyerName: buyerName });
          let sellerCustomers = this.props.customers.filter(
            customers => customers.id !== doc.id
          );
          this.setState({ sellerCustomers });
        }
      });
    this.handleDialogClose();
  };
  handleBuyerChange = event => {
    let buyerName = this.props.customers.find(o => o.id === event.target.value)
      .name;
    this.setState({ buyerId: event.target.value, currentBuyerName: buyerName });
    let sellerCustomers = this.props.customers.filter(
      customers => customers.id !== event.target.value
    );
    this.setState({ sellerCustomers });
  };
  handleRateChange = name => event => {
    this.setState({ [name]: event.target.value });
    this.calculateTotalAmount(event.target.value);
  };
  calculateTotalAmount = rate => {
    let amount = this.state.quantity * rate;
    this.setState({ amount });
  };
  handleOpenSnackBar = snackbarMessage => {
    this.setState({ openSnackBar: true, snackbarMessage: snackbarMessage });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openSnackBar: false });
  };
  handleCreateDialogEntrySelection = (entryData, dialogFor) => {
    this.props.handleCreateDialogEntry(entryData, dialogFor).then(doc => {
      if (dialogFor === "addNewProduct") {
        let productName = this.props.products.find(o => o.id === doc.id)
          .productName;
        this.setState({ currentProduct: productName });
      } else if (dialogFor === "addNewUnit") {
        this.setState({ unit: doc.id });
      } else if (dialogFor === "addDealQuality") {
        let dealQuality = this.props.dealQuality.find(o => o.id === doc.id)
          .name;
        this.setState({ currentDealQuality: dealQuality });
      } else if (dialogFor === "addBardanaCondition") {
        let bardanaName = this.props.bardanaCondition.find(o => o.id === doc.id)
          .name;
        this.setState({ currentBardanaCondition: bardanaName });
      } else if (dialogFor === "addDispatchCondition") {
        let dispatchName = this.props.dispatchCondition.find(
          o => o.id === doc.id
        ).name;
        this.setState({ currentDispatchCondition: dispatchName });
      }
    });
    this.handleCloseAddNewDialog();
  };
  render() {
    const {
      addDeal,
      user,
      units,
      products,
      classes,
      bardanaCondition,
      dealQuality,
      dispatchCondition,
      handleBardanaDispatchAdd,
      handleCreateDialogEntry
    } = this.props;
    const {
      gstCondition,
      typeOfRate,
      currentProduct,
      currentGSTCondition,
      currentTypeOfRate,
      date,
      buyerId,
      sellerId,
      sellerCustomers,
      buyerCustomers,
      snackbarMessage,
      organisationId,
      panNumber,
      gstNumber,
      tinNumber,
      truckTrolla,
      truckTrollaName,
      truckTrollaQuantity,
      sellerThrough,
      buyerThrough,
      currentBardanaCondition,
      currentDealQuality,
      currentDispatchCondition,
      bardanaDispatchName,
      entryName,
      dialogFor,
      openAddNewDialog,
      isLoading
    } = this.state;
    return (
      <Layout
        position="fixed"
        appBar
        appBarTitle="ADD DEAL"
        appBarLeftIcon={true}
      >
        {" "}
        {isLoading ? (
          <Loading />
        ) : (
          // this.props.history.push("/loading")
          <div
            style={{
              top: "66px",
              position: "absolute",
              width: "100vw",
              height: "calc(100vh - 66px)",
              display: "flex",
              flexDirection: "column"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "calc(100vh - 122px)",
                overflowY: "scroll"
              }}
            >
              <div style={{ display: "flex", flexDirection: "row" }}>
                <TextField
                  id="outlined-bare"
                  type="date"
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  defaultValue={Moment(date).format("YYYY-MM-DD")}
                  label="Date"
                  name="date"
                  required={true}
                  onChange={this.handleDateChange("date")}
                  InputLabelProps={{
                    shrink: true
                  }}
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  style={{ flex: 1 }}
                  required
                  id="outlined-required"
                  label="Truck/Trolla"
                  type="number"
                  onChange={this.handleChange("truckTrollaQuantity")}
                  className={classNames(classes.margin)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Select
                          value={this.state.truckTrollaName}
                          onChange={this.handleChange("truckTrollaName")}
                          inputProps={{
                            name: "age",
                            id: "age-simple"
                          }}
                        >
                          <MenuItem style={{ color: "grey" }} value="NONE">
                            None
                          </MenuItem>
                          {truckTrolla.map(data => (
                            <MenuItem style={{ color: "black" }} value={data}>
                              {data}
                            </MenuItem>
                          ))}
                        </Select>
                      </InputAdornment>
                    )
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "5px",
                    backgroundColor: "aliceblue",
                    borderRadius: "15px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    flex: 2.5
                  }}
                >
                  <TextField
                    select
                    // style={{ flex: 2 }}
                    className={classNames(classes.margin)}
                    variant="outlined"
                    label="Select SELLER"
                    value={sellerId}
                    required={true}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={this.handleCustomer("currentSellerName")}
                  >
                    <MenuItem style={{ color: "grey" }} value="NONE">
                      None
                    </MenuItem>
                    {sellerCustomers && sellerCustomers.length > 0
                      ? sellerCustomers.map(data => (
                          <MenuItem style={{ color: "black" }} value={data.id}>
                            {data.name}
                          </MenuItem>
                        ))
                      : ""}
                    <MenuItem style={{ color: "grey" }} value="add">
                      Add
                    </MenuItem>
                  </TextField>
                  <TextField
                    // style={{ flex: 2 }}
                    required
                    id="outlined-required"
                    label="Seller Brokerage"
                    type="number"
                    onChange={this.handleChange("sellerBrokerage")}
                    className={classNames(classes.margin)}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      )
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    // style={{ flex: 2 }}
                    name="sellerThrough"
                    label="Seller Through"
                    onChange={this.handleChange("sellerThrough")}
                    className={classNames(classes.margin)}
                    InputLabelProps={{
                      shrink: true
                    }}
                    variant="outlined"
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "5px",
                    backgroundColor: "antiquewhite",
                    borderRadius: "15px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    flex: 2.5
                  }}
                >
                  <TextField
                    select
                    // style={{ flex: 2 }}
                    className={classNames(classes.margin)}
                    variant="outlined"
                    label="Select BUYER"
                    value={buyerId}
                    required={true}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onChange={this.handleCustomer("currentBuyerName")}
                  >
                    <MenuItem style={{ color: "grey" }} value="NONE">
                      None
                    </MenuItem>
                    {buyerCustomers && buyerCustomers.length > 0
                      ? buyerCustomers.map(data => (
                          <MenuItem style={{ color: "black" }} value={data.id}>
                            {data.name}
                          </MenuItem>
                        ))
                      : ""}
                    <MenuItem style={{ color: "grey" }} value="add">
                      Add
                    </MenuItem>
                  </TextField>

                  <TextField
                    // style={{ flex: 2 }}
                    required
                    id="outlined-required"
                    label="Buyer Brokerage"
                    type="number"
                    onChange={this.handleChange("buyerBrokerage")}
                    className={classNames(classes.margin)}
                    InputLabelProps={{
                      shrink: true
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">₹</InputAdornment>
                      )
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    // style={{ flex: 2 }}
                    name="buyerThrough"
                    label="Buyer Through"
                    onChange={this.handleChange("buyerThrough")}
                    className={classNames(classes.margin)}
                    InputLabelProps={{
                      shrink: true
                    }}
                    variant="outlined"
                  />
                </div>
              </div>

              <div style={{ display: "flex", flexDirection: "row" }}>
                <TextField
                  select
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  variant="outlined"
                  label="Product"
                  value={currentProduct}
                  required={true}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange("currentProduct")}
                >
                  <MenuItem style={{ color: "grey" }} value="NONE">
                    None
                  </MenuItem>
                  {products && products.length > 0
                    ? products.map(data => (
                        <MenuItem
                          style={{ color: "black" }}
                          value={data.productName}
                        >
                          {data.productName}
                        </MenuItem>
                      ))
                    : ""}
                  <MenuItem style={{ color: "grey" }} value="addNewProduct">
                    Add
                  </MenuItem>
                </TextField>

                <TextField
                  style={{ flex: 1 }}
                  required
                  id="outlined-required"
                  label="Quantity"
                  type="number"
                  onChange={this.handleChange("quantity")}
                  className={classNames(classes.margin)}
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Select
                          value={this.state.unit}
                          onChange={this.handleChange("unit")}
                          inputProps={{
                            name: "age",
                            id: "age-simple"
                          }}
                        >
                          <MenuItem style={{ color: "grey" }} value="NONE">
                            None
                          </MenuItem>
                          {units && units
                            ? units.map(data => (
                                <MenuItem
                                  style={{ color: "black" }}
                                  value={data.id}
                                >
                                  {data.unitName}
                                </MenuItem>
                              ))
                            : ""}
                          <MenuItem
                            style={{ color: "grey" }}
                            value="addNewUnit"
                          >
                            Add
                          </MenuItem>
                        </Select>
                      </InputAdornment>
                    )
                  }}
                  margin="normal"
                  variant="outlined"
                />
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <TextField
                  style={{ flex: 1 }}
                  id="outlined-required"
                  className={classNames(classes.margin)}
                  required
                  label="Rate"
                  type="number"
                  onChange={this.handleRateChange("rate")}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">₹</InputAdornment>
                    )
                  }}
                />
                <TextField
                  select
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  variant="outlined"
                  label="GST Condition"
                  value={currentGSTCondition}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange("currentGSTCondition")}
                >
                  <MenuItem style={{ color: "grey" }} value="NONE">
                    None
                  </MenuItem>
                  {gstCondition.map(data => (
                    <MenuItem style={{ color: "black" }} value={data}>
                      {data}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  variant="outlined"
                  label="Type of Rate"
                  value={currentTypeOfRate}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange("currentTypeOfRate")}
                >
                  <MenuItem style={{ color: "grey" }} value="NONE">
                    None
                  </MenuItem>
                  {typeOfRate.map(data => (
                    <MenuItem style={{ color: "black" }} value={data}>
                      {data}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <TextField
                  select
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  variant="outlined"
                  label="Bardana Condition"
                  value={currentBardanaCondition}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange("currentBardanaCondition")}
                >
                  <MenuItem style={{ color: "grey" }} value="NONE">
                    None
                  </MenuItem>
                  {bardanaCondition && bardanaCondition.length > 0
                    ? bardanaCondition.map(data => (
                        <MenuItem style={{ color: "black" }} value={data.name}>
                          {data.name}
                        </MenuItem>
                      ))
                    : ""}
                  <MenuItem
                    style={{ color: "grey" }}
                    value="addBardanaCondition"
                  >
                    Add
                  </MenuItem>
                </TextField>
                <TextField
                  select
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  variant="outlined"
                  label="Dispatch Condition"
                  value={currentDispatchCondition}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange("currentDispatchCondition")}
                >
                  <MenuItem style={{ color: "grey" }} value="NONE">
                    None
                  </MenuItem>
                  {dispatchCondition && dispatchCondition.length > 0
                    ? dispatchCondition.map(data => (
                        <MenuItem style={{ color: "black" }} value={data.name}>
                          {data.name}
                        </MenuItem>
                      ))
                    : ""}
                  <MenuItem
                    style={{ color: "grey" }}
                    value="addDispatchCondition"
                  >
                    Add
                  </MenuItem>
                </TextField>

                <TextField
                  select
                  style={{ flex: 1 }}
                  className={classNames(classes.margin)}
                  variant="outlined"
                  label="Quality"
                  value={currentDealQuality}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onChange={this.handleChange("currentDealQuality")}
                >
                  <MenuItem style={{ color: "grey" }} value="NONE">
                    None
                  </MenuItem>
                  {dealQuality && dealQuality.length > 0
                    ? dealQuality.map(data => (
                        <MenuItem style={{ color: "black" }} value={data.name}>
                          {data.name}
                        </MenuItem>
                      ))
                    : ""}
                  <MenuItem style={{ color: "grey" }} value="addDealQuality">
                    Add
                  </MenuItem>
                </TextField>
              </div>
              <TextField
                name="description"
                label="Description"
                multiline
                rows="4"
                rowsMax="4"
                onChange={this.handleChange("description")}
                className={classNames(classes.margin)}
                InputLabelProps={{
                  shrink: true
                }}
                variant="outlined"
              />
              <Snackbar
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center"
                }}
                open={this.state.openSnackBar}
                autoHideDuration={3000}
                onClose={this.handleClose}
              >
                <MySnackbarContentWrapper
                  onClick={this.handleClose}
                  variant="warning"
                  message={snackbarMessage}
                />
              </Snackbar>
            </div>
            <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">
                Add
                {this.state.currentCustomer === "currentBuyerName"
                  ? " New Buyer"
                  : " New Seller"}
              </DialogTitle>
              <DialogContent>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-evenly"
                  }}
                >
                  <TextField
                    id="outlined-required"
                    label="Name"
                    onChange={this.handleChange("name")}
                    InputLabelProps={{
                      shrink: true
                    }}
                    required={true}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    id="outlined-required"
                    label="E-mail"
                    onChange={this.handleChange("email")}
                    InputLabelProps={{
                      shrink: true
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    id="outlined-required"
                    label="Ph. Number"
                    type="number"
                    onChange={this.handleChange("phoneNumber")}
                    InputLabelProps={{
                      shrink: true
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    id="outlined-required"
                    label="GST Number"
                    type="text"
                    onChange={this.handleChange("gstNumber")}
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={gstNumber}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    id="outlined-required"
                    label="Pan Number"
                    type="text"
                    onChange={this.handleChange("panNumber")}
                    InputLabelProps={{
                      shrink: true
                    }}
                    value={panNumber}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    id="outlined-required"
                    label="Tin Number"
                    type="number"
                    onChange={this.handleChange("tinNumber")}
                    InputLabelProps={{
                      shrink: true
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                  <TextField
                    id="outlined-required"
                    label="Address"
                    onChange={this.handleChange("address")}
                    InputLabelProps={{
                      shrink: true
                    }}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={e => {
                    e.preventDefault();
                    this.handleDialogClose();
                  }}
                  color="primary"
                >
                  Cancel
                </Button>
                <Button
                  onClick={e => {
                    e.preventDefault();
                    if (this.state.name !== "") {
                      this.handleCustomerAdd(this.state.currentCustomer);
                      console.log("Name Not Empty");
                    } else {
                      this.handleOpenSnackBar(
                        "Name must be provided before adding new customer...!"
                      );
                      console.log("Name Empty");
                    }
                  }}
                  color="primary"
                >
                  Add
                </Button>
              </DialogActions>
            </Dialog>
            <div
              style={{
                display: "flex",
                width: "100%",
                height: "56px",
                position: "absolute",
                bottom: "0px",
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={e => {
                  e.preventDefault();
                  if (
                    this.state.currentSellerName !== "" &&
                    this.state.currentSellerName !== "NONE" &&
                    this.state.sellerId &&
                    this.state.buyerId !== "" &&
                    this.state.currentBuyerName !== "" &&
                    this.state.currentBuyerName !== "NONE" &&
                    this.state.currentProduct !== "" &&
                    this.state.currentProduct !== "NONE" &&
                    this.state.quantity !== "" &&
                    this.state.currentGSTCondition !== "" &&
                    this.state.currentTypeOfRate !== "" &&
                    this.state.rate !== "" &&
                    this.state.unit !== "" &&
                    this.state.unit !== "NONE" &&
                    this.state.activeStatus !== "" &&
                    this.state.date !== "" &&
                    user.uid !== "" &&
                    this.state.buyerBrokerage !== "" &&
                    this.state.sellerBrokerage !== "" &&
                    this.state.amount !== "" &&
                    this.state.quantity !== "" &&
                    this.state.truckTrollaName !== "NONE" &&
                    this.state.truckTrollaQuantity !== ""
                  ) {
                    addDeal(
                      this.state.currentSellerName,
                      this.state.sellerId,
                      this.state.buyerId,
                      this.state.currentBuyerName,
                      this.state.currentProduct,
                      this.state.quantity,
                      this.state.currentGSTCondition,
                      this.state.currentTypeOfRate,
                      this.state.rate,
                      this.state.activeStatus,
                      this.state.date,
                      user.uid,
                      this.state.buyerBrokerage,
                      this.state.sellerBrokerage,
                      this.state.amount,
                      0,
                      this.state.quantity,
                      this.state.unit,
                      0,
                      this.state.description,
                      false,
                      false,
                      organisationId,
                      truckTrollaQuantity,
                      truckTrollaName,
                      new Date(),
                      sellerThrough,
                      buyerThrough,
                      currentDispatchCondition,
                      currentDealQuality,
                      currentBardanaCondition
                    );
                    this.setState({ isLoading: true }, () => {
                      console.log(1);
                    });
                  } else {
                    this.handleOpenSnackBar(
                      "Please fill fields marked with * before adding deal...!"
                    );
                  }
                }}
                style={{
                  backgroundColor: "primary",
                  color: "white",
                  width: "100%",
                  height: "100%"
                }}
              >
                ADD DEAL
              </Button>
              <AddNewDialog
                dialogOpen={openAddNewDialog}
                dialogClose={this.handleCloseAddNewDialog}
                dialogFor={dialogFor}
                entryName={entryName}
                handleChange={this.handleChange}
                user={user}
                handleCreateDialogEntry={this.handleCreateDialogEntrySelection}
                organisationId={organisationId}
              />
            </div>
          </div>
        )}
      </Layout>
    );
  }
}
Deals.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(stylesMain)(Deals));
